var letters = 
['අ','ඉ','ඊ','උ','එ','ඔ',
'ක','කා','කැ','කෑ','කි','කී','කු','කූ','කේ','කො','කෝ',
'ග','ගා','ගැ','ගෑ','ගි','ගී','ගු','ගූ','ගේ','ගො','ගෝ','ඟ',
'ච','ඡ',
'ජ','ජා','ජැ','ජෑ','ජි','ජී','ජු','ජූ','ජේ','ජො','ජෝ',
'ඤ','ඥ',
'ට','ටා','ටැ','ටෑ','ටි','ටී','ටු','ටූ','ටේ','ටො','ටෝ',
'ඩ','ණ','ඬ',
'ත','තා','තැ','තෑ','ති','තී','තු','තූ','තේ','තො','තෝ',
'ද','දා','දැ','දෑ','දි','දී','දු','දූ','දේ','දො','දෝ',
'න','නා','නැ','නෑ','නි','නී','නු','නූ','නේ','නො','නෝ','ඳ',
'ප','පා','පැ','පෑ','පි','පී','පු','පූ','පේ','පො','පෝ',
'බ','භ',
'ම','මා','මැ','මෑ','මි','මී','මු','මූ','මේ','මො','මෝ',
'ඹ','ය','ර','ල','ව','ශ','ෂ','ස','සා','සැ','සෑ','සි','සී','සු','සූ','සේ','සො','සෝ','හ','ළ','ළා','ළැ','ළෑ','ළි','ළී','ළු','ළූ','ළේ','ළො','ළෝ'];

const parag1 = "අඅඅඅඅඅඅඅඅ උඋඋඋඋඋඋඋ රරරරරරරරරරරර ඍඍඍඍඍඍඍ එඑඑඑඑඑඑ ඔඔඔඔඔඔඔඔඔ හහහහහහහහ ශශශශශශශශශ මමමමමමම ඹඹඹඹඹඹඹඹ සසසසසසසස ෂෂෂෂෂෂෂෂෂෂ දදදදදදදදදද ධධධධධධධධ චචචචචචචචචචච ඡඡඡඡඡඡඡඡඡඡඡ ඤඤඤඤඤඤඤඤ ඥඥඥඥඥඥඥඥ ;;;;;;; :::::::: ෆෆෆෆෆෆෆෆෆෆ ටටටටටටටටට ඨඨඨඨඨඨඨඨ යයයයයයයයයය වවවවවවවවවව නනනනනනනනන ණණණණණණණණ කකකකකකකක ඛඛඛඛඛඛඛඛඛ තතතතතතතතත ථථථථථථථථථථථ ......... ,,,,,,,,,, '''''''' \"\"\"\"\"\"\"\" ජජජජජජජජජජ ඣඣඣඣඣඣඣඣ ඩඩඩඩඩඩඩඩඩ ඪඪඪඪඪඪඪඪ ඉඉඉඉඉඉඉඉ ඊඊඊඊඊඊඊඊ බබබබබබබබ භභභභභභභ පපපපපපප ඵඵඵඵඵඵඵඵ ලලලලලලල ළළළළළළළ ගගගගගගග ඝඝඝඝඝඝඝ //////// ????????";
const parag2 = "අං අත අප අම අර අල අණ අද අග අඟ අට අඩ අඬ අඳ අබ අඹ අය අව අහ ඉත ඉම ඉර ඉල ඉණ ඉඟ ඉඩ ඉඳ ඉඹ ඉව ඉස ඉහ ඉළ උඩ උණ උප උඹ උය උර උල උස එක එබ එම එය එල එව එළ ඔං ඔද ඔඳ ඔප ඔබ ඔය ඔර ඔල ඔව ඔළ අගක අගට අගම";
const parag3 = "මා විසින් මෙසේ අසන ලදී: එක් කලෙක භාග්‍යවතුන් වහන්සේ සැවැත්නුවර සමීපයෙහි වූ ජෙතවන නම් අනේපිඬුසිටුහුගේ ආරාමයෙහි වැඩ වසන සේක. එකල්හි භාග්‍යවතුන් වහන්සේ 'මහණෙනි'යි භික්‍ෂූන් ඇමතූ සේක. භික්‍ෂූහු 'වහන්සැ'යි භාග්‍යවතුන් වහන්සේට පිළිවදන් දුන්හ. භාග්‍යවතුන් වහන්සේ මේ සූත්රය වදාළ සේක. මහණෙනි, පිරිසුදු පබසර වතක් වේ ද, එය රජකයෙක් නිල්පැහැය පිණිස හෝ රන්වන්පැහැය පිණිස හෝ ලේවන්පැහැය පිණිස හෝ මදටිය පැහැය පිණිස හෝ යම් යම් රඳනෙක බහා ලන්නේ නම්, එය මනා පැහැ ඇත්තක් ම වන්නේ ය. පිරිසිදු පැහැ ඇත්තක් ම වන්නේ ය. ඒ කවර හෙයින යත්: මහණෙනි, වස්ත්‍රය පිරිසිදු බැවිනි. මහණෙනි, එපරිද්දෙන් ම සිත නො කිලිටි වූ කල්හි සුගතිය ම කැමැති විය යුතු යි.";
export const paralist = (level) => {
    switch(level){
        case 1:
            return letters; 
        case 2:
            return parag2.split(" ");
        case 3:
            return parag3.split(" ");
        default:
            return parag1.split(""); 

    }
    
};



export const sinhalaRand = () => {
    var verb = "";
    for(var i =0; i< Math.floor(Math.random()*9+1); i++){
        verb += letters[Math.floor(Math.random()*letters.length)];
    }
    return verb;
};

export const sinhalize = (word = " ") => {
        
    if(word === " ") return word;
    else{
        var verb = "";
        for(var i =0; i< word.length; i++){
            
            verb += letters[Math.floor(word.charCodeAt(i)%letters.length)];
            
        }
        return verb;
    }
};